import { createFileRoute, Link, Outlet } from '@tanstack/react-router'

import styles from './base-layout.module.scss'
import { useAtom } from 'jotai'
import { userAtom } from '@/store/atoms/user.atom'
import { currencyFormat } from '@/utils/currency-format'
import { userServiceInstance } from '@/services/user.service'
import { useEffect } from 'react'
import { NotificationContextProvider } from '@/contexts/notification-context-provider'

export const Route = createFileRoute('/mobile/__base-layout')({
  component: RouteComponent,
  loader: async () => {
    try {
      const wallet = await userServiceInstance.wallet()

      return wallet
    } catch (err) {
      throw err
    }
  },
  shouldReload: true,
})

function RouteComponent() {
  const amount = Route.useLoaderData()
  const [user, setUser] = useAtom(userAtom)

  useEffect(() => {
    if (!user) return
    console.log("🚀 ~ file: index.tsx:17 ~ useEffect ~ amount", amount)
    setUser({
      ...user,
      wallet: {
        ...user.wallet,
        amount
      }
    })
  }, [amount])

  return (
    <NotificationContextProvider>
    <div className={styles.container}>
      <header>
        <div className={styles.header_coins}>
          <img
            src="/assets/coin.svg"
          />
          <span>{currencyFormat(user?.wallet.amount ?? 0)}</span>
        </div>

        <div className={styles.header_actions}>
          <Link to="/mobile/home">
            <img src="/assets/home.png" />
          </Link>
          <Link to="/mobile/profile">
            <img src="/assets/menu.png" />
          </Link>
        </div>
      </header>
      <div>
        <Outlet />
      </div>
    </div>
    </NotificationContextProvider>
  )
}
